import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { MarketAnalysisService } from 'src/app/services/market-analysis.service';

@Component({
  selector: 'app-market-companies-that-you-compete',
  templateUrl: './market-companies-that-you-compete.component.html',
  styleUrls: ['./market-companies-that-you-compete.component.scss']
})
export class MarketCompaniesThatYouCompeteComponent implements OnInit {
  @Output() onsaveMarket: EventEmitter<any> = new EventEmitter<any>();
  @Output() Resultado: EventEmitter<any> = new EventEmitter<any>();
  marketAnalysisClientCompatitorsData: any;
  _formMarketCompetitors: FormGroup;
  popupNewItem = false;
  constructor(
    private marketAnalysisService: MarketAnalysisService,
    private toast: ToastService) {
    this.initMarketCompetitors(null);

    this.marketAnalysisService.GetMarketAnalysisClientCompetitors().subscribe(result => {
      this.marketAnalysisClientCompatitorsData = result;
    });
   }

  ngOnInit() {
  }

  initMarketCompetitors(item?: any) {
    this._formMarketCompetitors = new FormGroup({
      id: new FormControl({ value: '', disabled: false }, []),
      name: new FormControl({ value: '', disabled: false }, []),
      address1: new FormControl({ value: '', disabled: false }, []),
      city: new FormControl({ value: '', disabled: false }, []),
      state: new FormControl({ value: '', disabled: false }, []),
      zip: new FormControl({ value: '', disabled: false }, []),
      phone: new FormControl({ value: '', disabled: false }, []),
      manufacturer: new FormControl({ value: '', disabled: false }, []),
      principal1: new FormControl({ value: '', disabled: false }, []),
      principal2: new FormControl({ value: '', disabled: false }, []),
      principal3: new FormControl({ value: '', disabled: false }, []),
      size: new FormControl({ value: 0, disabled: false }, []),
      annualrevenue: new FormControl({ value: 0, disabled: false }, []),
      curterate: new FormControl({ value: 0, disabled: false }, []),
      curinstallerrate: new FormControl({ value: 0, disabled: false }, []),
      hostiry: new FormControl({ value: '', disabled: false }, []),
      notes: new FormControl({ value: '', disabled: false }, []),
      strengths: new FormControl({ value: '', disabled: false }, []),
      weakness: new FormControl({ value: '', disabled: false }, []),
    });
  }
  
  goEditCompetitor(item) {

    this._formMarketCompetitors.get('id').setValue(item.ID);
    this._formMarketCompetitors.get('name').setValue(item.NAME);
    this._formMarketCompetitors.get('address1').setValue(item.ADDRESS1);
    this._formMarketCompetitors.get('city').setValue(item.CITY);
    this._formMarketCompetitors.get('state').setValue(item.STATE);
    this._formMarketCompetitors.get('zip').setValue(item.ZIP);
    this._formMarketCompetitors.get('phone').setValue(item.PHONE);
    this._formMarketCompetitors.get('manufacturer').setValue(item.MANUFACTURER);
    this._formMarketCompetitors.get('principal1').setValue(item.PRICIPAL1);
    this._formMarketCompetitors.get('principal2').setValue(item.PRICIPAL2);
    this._formMarketCompetitors.get('principal3').setValue(item.PRICIPAL3);
    var msize = 0
    if( item.SIZE ) {
      msize = item.SIZE;
    }
    this._formMarketCompetitors.get('size').setValue(msize);
    var mannualrevenue = 0
    if( item.SIZE ) {
      mannualrevenue = item.ANNUALREVENUE;
    }
    this._formMarketCompetitors.get('annualrevenue').setValue(mannualrevenue);
    var mcurttechrate = 0
    if( item.CURTECHRATE ) {
      mcurttechrate = item.CURTECHRATE;
    }
    this._formMarketCompetitors.get('curterate').setValue(mcurttechrate);
    var mcurtinstallrate = 0
    if( item.CURINSTALLERRATE ) {
      mcurtinstallrate = item.CURINSTALLERRATE;
    }
    this._formMarketCompetitors.get('curinstallerrate').setValue(mcurtinstallrate);
    this._formMarketCompetitors.get('hostiry').setValue(item.HOSTIRY);
    this._formMarketCompetitors.get('notes').setValue(item.NOTES);
    this._formMarketCompetitors.get('strengths').setValue(item.STRENGTHS);
    this._formMarketCompetitors.get('weakness').setValue(item.WEAKNESS);

    this.popupNewItem = true;

  }
  saveCompetitors(){

    let formValue;
    formValue = this._formMarketCompetitors.value;

    this.marketAnalysisService.SaveMarketAnalysisClientCompetitors(formValue).subscribe(result => {
      this.popupNewItem = false;
      this.toast.success('Successfully Updated');
      this.Resultado.emit(result)
      this.marketAnalysisService.GetMarketAnalysisClientCompetitors().subscribe(result => {
        this.marketAnalysisClientCompatitorsData = result;
        // this.onsaveMarket.emit(true)
      });
    });
  }

  goNewCompetitor() {

    this._formMarketCompetitors.get('id').setValue(0);
    this._formMarketCompetitors.get('name').setValue('');
    this._formMarketCompetitors.get('address1').setValue('');
    this._formMarketCompetitors.get('city').setValue('');
    this._formMarketCompetitors.get('state').setValue('');
    this._formMarketCompetitors.get('zip').setValue('');
    this._formMarketCompetitors.get('phone').setValue('');
    this._formMarketCompetitors.get('manufacturer').setValue('');
    this._formMarketCompetitors.get('principal1').setValue('');
    this._formMarketCompetitors.get('principal2').setValue('');
    this._formMarketCompetitors.get('principal3').setValue('');
    this._formMarketCompetitors.get('size').setValue(0);
    this._formMarketCompetitors.get('annualrevenue').setValue(0);
    this._formMarketCompetitors.get('curterate').setValue(0);
    this._formMarketCompetitors.get('curinstallerrate').setValue(0);
    this._formMarketCompetitors.get('hostiry').setValue('');
    this._formMarketCompetitors.get('notes').setValue('');
    this._formMarketCompetitors.get('strengths').setValue('');
    this._formMarketCompetitors.get('weakness').setValue('');

    this.popupNewItem = true;

  }

  

}
